import {useMemo, useState} from 'react'
import './ConsolidationFilter.scss'
import {FmlxButton, FmlxCheckBox} from "fmlx-common-ui";
import {FMLX_BUTTON, FMLX_COMPONENT,} from "../../const/FmlxComponentEnum";
import PropTypes from "prop-types";
import {ConsolidationFilterType} from '../../const/dataEnum';


export default function ConsolidationFilter({dataFirstRender, setReviewList}) {

  const memoizedFirstDataConsolidation = useMemo(() => {
    return dataFirstRender
  }, [dataFirstRender])

  const [selectedFilterConsolidation, setSelectedFilterConsolidation] = useState({
    practiceFilter: [],
    roleFilter: []
  })

  const configurationFilter = (dataFilter) => {
    if (dataFilter.roleFilter.length > 0 || dataFilter.practiceFilter.length > 0) {
      const filterData = {
        ...dataFirstRender,
        generalReviews: dataFirstRender.generalReviews.map((item) => {
          const defineSelectedConditionRole = new Set(dataFilter.roleFilter)
          const defineSelectedConditionPractice = new Set(dataFilter.practiceFilter)
          if (item?.answers?.length > 0) {
            return {
              ...item,
              answers: item?.answers.filter((itemAnswer) => {
                if (dataFilter.roleFilter.length > 0 && dataFilter.practiceFilter.length > 0) {
                  if (defineSelectedConditionRole.has(itemAnswer.reviewType) && defineSelectedConditionPractice.has(itemAnswer.practiceName)) {
                    return itemAnswer
                  }
                } else if (defineSelectedConditionRole.has(itemAnswer.reviewType)) {
                  return itemAnswer
                } else if (defineSelectedConditionPractice.has(itemAnswer.practiceName)) {
                  return itemAnswer
                }
                return null
              })
            }
          } else {
            return null
          }
        }),
        skillReviews: dataFirstRender.skillReviews.map((item) => {
          const defineSelectedConditionRole = new Set(dataFilter.roleFilter)
          const defineSelectedConditionPractice = new Set(dataFilter.practiceFilter)
          if (item?.answers?.length > 0) {
            return {
              ...item,
              answers: item?.answers.filter((itemAnswer) => {
                if (dataFilter.roleFilter.length > 0 && dataFilter.practiceFilter.length > 0) {
                  if (defineSelectedConditionRole.has(itemAnswer.reviewType) && defineSelectedConditionPractice.has(itemAnswer.practiceName)) {
                    return itemAnswer
                  }
                } else if (defineSelectedConditionRole.has(itemAnswer.reviewType)) {
                  return itemAnswer
                } else if (defineSelectedConditionPractice.has(itemAnswer.practiceName)) {
                  return itemAnswer
                }

                return null
              })
            }
          } else {
            return item
          }
        }),
      }
      setReviewList(filterData)

    }

  }

  const modifyRole = (value) => {
    const checkValue = selectedFilterConsolidation?.roleFilter.find((item) => item === value)
    if (!checkValue) {
      const filterDataRole = {
        ...selectedFilterConsolidation,
        roleFilter: [...selectedFilterConsolidation.roleFilter, value]
      }

      configurationFilter(filterDataRole)

      return setSelectedFilterConsolidation({
        ...selectedFilterConsolidation,
        roleFilter: [...selectedFilterConsolidation.roleFilter, value]
      })
    }

    // variable for check length updated in selectedConsolidation
    const checkLengthSelectedConsolidation = selectedFilterConsolidation.roleFilter.filter((item) => item !== value)

    if (checkLengthSelectedConsolidation?.length > 0) {
      const filterDataPractice = {
        ...selectedFilterConsolidation,
        roleFilter: selectedFilterConsolidation.roleFilter.filter((item) => item !== value)
      }
      configurationFilter(filterDataPractice)
    } else {
      setReviewList(memoizedFirstDataConsolidation)
    }
    return setSelectedFilterConsolidation({
      ...selectedFilterConsolidation,
      roleFilter: selectedFilterConsolidation.roleFilter.filter((item) => item !== value)
    })
  }

  const modifyPractice = (value) => {
    const checkValue = selectedFilterConsolidation?.practiceFilter.find((item) => item === value)
    if (!checkValue) {
      const filterDataPractice = {
        ...selectedFilterConsolidation,
        practiceFilter: [...selectedFilterConsolidation.practiceFilter, value]
      }

      configurationFilter(filterDataPractice)

      return setSelectedFilterConsolidation({
        ...selectedFilterConsolidation,
        practiceFilter: [...selectedFilterConsolidation.practiceFilter, value]
      })
    }

    // variable for check length updated in selectedConsolidation
    const checkLengthSelectedConsolidation = selectedFilterConsolidation.practiceFilter.filter((item) => item !== value)

    if (checkLengthSelectedConsolidation?.length > 0) {
      const filterDataPractice = {
        ...selectedFilterConsolidation,
        practiceFilter: selectedFilterConsolidation.practiceFilter.filter((item) => item !== value)
      }
      configurationFilter(filterDataPractice)
    } else {
      setReviewList(memoizedFirstDataConsolidation)
    }
    return setSelectedFilterConsolidation({
      ...selectedFilterConsolidation,
      practiceFilter: selectedFilterConsolidation.practiceFilter.filter((item) => item !== value)
    })
  }

  const handleOnChangeFilterPractice = (valueSelected, type) => {
    if (type === ConsolidationFilterType.ROLE_TYPE) {
      console.log('masuk')
      modifyRole(valueSelected)
    } else {
      modifyPractice(valueSelected)
    }
  }

  const handleClearDataFilter = () => {
    setSelectedFilterConsolidation({
      practiceFilter: [],
      roleFilter: []
    })
    setReviewList(dataFirstRender)
  }

  const extractRolesAndPractices = (data) => {
    const dataRole = new Set()
    const dataPractice = new Set()

    data?.generalReviews?.forEach(review => {
      review?.answers?.forEach((item) => {
        dataRole.add(item.reviewType)
        dataPractice.add(item.practiceName)
      })
    });

    const resultRole = Array.from(dataRole).sort().map(role => ({
      roleName: role,
    }));

    const resultPractice = Array.from(dataPractice).sort().map(practice => ({
      practiceName: practice,
    }));

    return {
      role: resultRole,
      practice: resultPractice
    }
  }

  const dataFilter = extractRolesAndPractices(dataFirstRender)
  const selectedDataPractice = (item) => (
    selectedFilterConsolidation.practiceFilter.find((itemFind) => itemFind === item.practiceName)
  )
  const selectedDataRole = (item) => (
    selectedFilterConsolidation.roleFilter.find((itemFind) => itemFind === item.roleName)
  )

  return (
    <>
      <div className='titleContent'>
        Role
      </div>
      {dataFilter?.role.map(item => (
        <div key={item.roleName}>
          <div className="filterContent">
            <FmlxCheckBox
              checked={selectedDataRole(item)}
              id="Role"
              key={item.roleName}
              onChange={() => handleOnChangeFilterPractice(item.roleName, 'role')}
            />
            <span>{item.roleName}</span>
          </div>
        </div>
      ))}

      <div className='titleContent'>
        Practice
      </div>
      {dataFilter?.practice.map(item => (
        <div key={item.practiceName}>
          <div className="filterContent">
            <FmlxCheckBox
              checked={selectedDataPractice(item)}
              id="Practice"
              key={item.practiceId}
              onChange={() => handleOnChangeFilterPractice(item.practiceName, 'practice')}
            />
            <span>{item.practiceName}</span>
          </div>
        </div>
      ))}

      <div className="clearFilter">
        <FmlxButton
          size={FMLX_COMPONENT.SIZE.XL}
          type={FMLX_BUTTON.TYPE.DANGER}
          variant={FMLX_BUTTON.VARIANT.OUTLINE}
          disabled={false}
          label="Clear Filter"
          onClick={() => handleClearDataFilter()}
          style={{cursor: "pointer"}}
          onlyIcon={false}
          withTooltip={false}
          tooltipPlacement={"top"}
          tooltipDescription={"Clear Filter"}

        ></FmlxButton>
      </div>
    </>
  )
}

ConsolidationFilter.propTypes = {
  dataFirstRender: PropTypes.object,
  selectedFilterConsolidation: PropTypes.object,
  setReviewList: PropTypes.func,
  setSelectedFilterConsolidation: PropTypes.func,
};
